<div
  class="tw-flex tw-min-h-screen tw-items-center tw-justify-center tw-bg-dt-surface-elevated tw-p-4"
>
  <div
    class="tw-flex tw-w-full tw-max-w-md tw-flex-col tw-gap-6 tw-rounded-xl tw-bg-dt-surface-card tw-p-8 tw-shadow-sm"
  >
    <div class="tw-flex tw-flex-col tw-items-center tw-gap-2 tw-text-center">
      <h1 class="tw-text-xl tw-font-semibold tw-text-dt-text-headings">
        {{ "emergencyAccess" | i18n }}
      </h1>
      <p *ngIf="grantorName || grantorEmail" class="tw-text-sm tw-text-dt-text-tertiary">
        {{ "invitedUser" | i18n }}
        <span class="tw-font-medium tw-text-dt-text-secondary">{{
          grantorName || grantorEmail
        }}</span>
      </p>
    </div>

    <!-- Error state -->
    <div
      *ngIf="error"
      class="tw-rounded tw-bg-dt-surface-out tw-p-3 tw-text-sm tw-text-dt-text-error"
    >
      {{ error }}
    </div>

    <!-- Authenticated state: pending accept -->
    <div *ngIf="isAuthenticated && id && token && !loading" class="tw-flex tw-flex-col tw-gap-3">
      <app-gloss-button
        [options]="{
          text: 'emergencyAccess' | i18n,
          class: 'primary',
          isEnabled: true,
          onClick: accept.bind(this),
        }"
      ></app-gloss-button>
    </div>

    <!-- Unauthenticated state -->
    <ng-container *ngIf="!isAuthenticated">
      <p class="tw-text-center tw-text-sm tw-text-dt-text-secondary">
        {{ "acceptEmergencyAccess" | i18n }}
      </p>
      <div class="tw-flex tw-flex-col tw-gap-3">
        <app-gloss-button
          [options]="{
            text: 'logIn' | i18n,
            class: 'primary',
            isEnabled: true,
            onClick: navigateToLogin.bind(this),
          }"
        ></app-gloss-button>
      </div>
    </ng-container>

    <!-- Loading state -->
    <div *ngIf="loading" class="tw-flex tw-justify-center tw-py-4">
      <i
        class="bwi bwi-spinner bwi-spin tw-text-2xl tw-text-dt-text-disabled"
        aria-hidden="true"
      ></i>
    </div>
  </div>
</div>
